import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";


function am4themes_crosland(target) {
  if (target instanceof am4core.ColorSet) {
    target.list = [
      am4core.color("#3699FF"),
      am4core.color("#F64E60")
    ];
  }
}

am4core.useTheme(am4themes_animated);
am4core.useTheme(am4themes_crosland);

function initAmCharts() {
  am4core.addLicense("CH234196226");
}


export { am4core, am4charts, initAmCharts };